import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsEA: CultureInfo = {
  name: 'es-EA',
  displayName: 'español (Ceuta y Melilla)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-EA',
  parent: CultureInfoEs
};
